var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center"}},[_c('b-button',{attrs:{"to":{name:'impressum'},"variant":"flat-secondary","size":"sm"}},[_vm._v(" Impressum ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }